
import { Types } from "../types"
import { GetCallQueueReportByRecordNameErrorPayLoad, GetCallQueueReportByRecordNameRequestPayload, GetCallQueueReportByRecordNameSuccessPayload, GetCallQueueReportErrorPayLoad, GetCallQueueReportRequestPayload, GetCallQueueReportSuccessPayload } from "../interfaces/callQueueReport"
import { GetCallQueueReportByRecordNameError, GetCallQueueReportByRecordNameRequest, GetCallQueueReportByRecordNameSuccess, GetCallQueueReportError, GetCallQueueReportRequest, GetCallQueueReportSuccess } from "../types/callQueueReport/actionType"


//getCallQueueReport********************************************************************************************************
export const getCallQueueReportRequestAction = (payload: GetCallQueueReportRequestPayload): GetCallQueueReportRequest => ({
    type: Types.GET_CALL_QUEUE_REPORT_REQUEST,
    payload
})

export const getCallQueueReportSuccessAction = (payload: GetCallQueueReportSuccessPayload): GetCallQueueReportSuccess => ({
    type: Types.GET_CALL_QUEUE_REPORT_SUCCESS,
    payload
})

export const getCallQueueReportErrorAction = (payload: GetCallQueueReportErrorPayLoad): GetCallQueueReportError => ({
    type: Types.GET_CALL_QUEUE_REPORT_ERROR,
    payload
})
//getCallQueueReportByRecordName********************************************************************************************************
export const getCallQueueReportByRecordNameRequestAction = (payload: GetCallQueueReportByRecordNameRequestPayload): GetCallQueueReportByRecordNameRequest => ({
    type: Types.GET_CALL_QUEUE_BY_RECORD_NAME_REQUEST,
    payload
})

export const getCallQueueReportByRecordNameSuccessAction = (payload: GetCallQueueReportByRecordNameSuccessPayload): GetCallQueueReportByRecordNameSuccess => ({
    type: Types.GET_CALL_QUEUE_BY_RECORD_NAME_SUCCESS,
    payload
})

export const getCallQueueReportByRecordNameErrorAction = (payload: GetCallQueueReportByRecordNameErrorPayLoad): GetCallQueueReportByRecordNameError => ({
    type: Types.GET_CALL_QUEUE_BY_RECORD_NAME_ERROR,
    payload
})
